import React, { FC } from 'react';

import { GapperResponse } from '../../../../lib/models/fundamental/types';
import TradePriceCache from '../../../../lib/store-util/TradePriceCache';
import { getPriceColorByDirection } from '../../../../lib/util/ChartingHelpers';
import { formatCurrency } from '../../../../lib/util/DataHelpers';
import { getSymbolFirstPart } from '../../../../lib/util/MarketDataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import styles from '../../HotGappers.module.scss';

type Props = { item: GapperResponse }

const PriceAndChange: FC<Props> = (props: Props): JSX.Element => {
  const { item } = props;
  if (!item) {
    return <>{INVALID_VALUE}</>;
  }

  const { symbol } = item;
  const { currentPrice, changePercent, direction } = TradePriceCache.use(getSymbolFirstPart(symbol), 'SymbolTradeInfoCard');
  const color = getPriceColorByDirection(direction);

  return (
    <div className={styles.priceAndChangeContainer}>
      <span className={styles.priceAndChange}>
        {formatCurrency(currentPrice ?? INVALID_VALUE)}
      </span>
      <p style={{ color }}>
        {direction}
        {changePercent ?? item.changePercent.toFixed(2)}
      </p>
    </div>
  );
};

export default PriceAndChange;
